export default function Marquee({ items, testId }) {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid={testId}
      aria-hidden="true"
      style={{
        position: "relative",
        overflow: "hidden",
        borderTop: "1px solid var(--separator)",
        borderBottom: "1px solid var(--separator)",
        background: "var(--surface-secondary)",
        padding: "34px 0",
      }}
    >
      <div className="cs-marquee-track" style={{ whiteSpace: "nowrap" }}>
        {doubled.map((item, i) => (
          <span
            key={i}
            className="font-display"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 40,
              paddingInline: 40,
              fontFamily: "var(--font-display)",
              fontSize: "clamp(38px, 5vw, 76px)",
              fontWeight: 500,
              fontStyle: i % 2 === 1 ? "italic" : "normal",
              color: i % 2 === 1 ? "var(--accent-ink)" : "var(--ink-primary)",
              letterSpacing: "-0.02em",
              lineHeight: 1,
              fontVariationSettings: '"opsz" 144, "SOFT" 30, "WONK" 0',
            }}
          >
            {item}
            <span aria-hidden="true" style={{ color: "var(--accent-ink)", fontSize: "0.6em", opacity: 0.7 }}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
